<section class="evs">

  <div class="admin-users__toolbar evs__toolbar">
    <p class="evs__hint">
      <%= _lcs( 'Externe Schnittstellen, aus denen BELTURO regionale Inhalte importiert — derzeit Veranstaltungen, später auch Sehenswürdigkeiten und Gastronomie. Der Import läuft künftig täglich automatisch — hier lässt er sich jederzeit manuell anstoßen.' ) %>
    </p>
  </div>

  <!-- Cards (or loading / empty / error message) are rendered here by EventSourceList.js -->
  <div class="evs__state" data-id="sources-state"></div>

  <!-- Edit modal (web component) -->
  <event-source-form data-id="evs-form"></event-source-form>

</section>
